function ReferenceAbrikoJamsController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	function initSliders(){
		var fruit = new Swiper('#fruit-slider', {
			effect: 'fade',
			slidesPerView: 1,
			speed: 700,
			loop: true,
			autoplay: {
				delay: 2500
			}
		});		
		var fruitMobile = new Swiper('#fruit-slider-mobile', {
			effect: 'fade',
			slidesPerView: 1,
			speed: 700,
			loop: true,
			autoplay: {
				delay: 2500
			}
		});		
		
		var productsBreakpoints = {};
		productsBreakpoints[Config.breakpoints.desktop] = { slidesPerView: 4 };
		productsBreakpoints[Config.breakpoints.tablet] = { slidesPerView: 4 };
		productsBreakpoints[Config.breakpoints.mobile] = { slidesPerView: 2 };
		productsBreakpoints[Config.breakpoints.mobileSmall] = { slidesPerView: 1 };
		var products = new Swiper('#product-slider', {
			effect: 'slide',
			slidesPerView: 5,
			speed: 500,
			loop: true,
			autoplay: false,
			centeredSlides: true,
			navigation: {
				prevEl: '.slider-prev',
				nextEl: '.slider-next'
			},
			breakpoints: productsBreakpoints
		});		
	}  
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// init
			initSliders();
			
			var parallax1 = new Rellax('.packshot', {
				speed: 1.5,
				center: true,
				wrapper: null,
				round: true,
				vertical: true,
				horizontal: false
			});	
			 
			Gridle.on('update', function (updatedStates, activeStates, inactiveStates) {
				parallax1.refresh();
			});			 
			 

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
